import { render } from "./PopupMenuBreak.vue?vue&type=template&id=33ff13c9&scoped=true"
const script = {}

import "./PopupMenuBreak.vue?vue&type=style&index=0&id=33ff13c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ff13c9"]])

export default __exports__